import React, { useState, useEffect } from 'react';
import './PromotionalBanner.css';

function PromotionalBanner({ tasks = {}, selectedDate }) {
  const [currentPromo, setCurrentPromo] = useState(0);

  const dateStr = selectedDate?.toISOString().split('T')[0];
  const dayTasks = tasks[dateStr] || [];

  // Filter shopping tasks
  const shoppingTasks = dayTasks.filter(task =>
    task.category?.toLowerCase() === 'shopping' ||
    task.text?.toLowerCase().includes('buy') ||
    task.text?.toLowerCase().includes('grocery') ||
    task.text?.toLowerCase().includes('milk') ||
    task.text?.toLowerCase().includes('store')
  );

  const promotions = [
    {
      icon: '🛒',
      title: 'Today\'s Deals',
      message: 'Save up to 30% on groceries at nearby stores!',
      color: '#4CAF50',
      action: 'View Deals'
    },
    {
      icon: '⚡',
      title: 'Quick Savings',
      message: 'Milk $2.99 | Bread $1.99 | Eggs $3.49 - Fresh & Local',
      color: '#2196F3',
      action: 'Shop Now'
    },
    {
      icon: '🎁',
      title: 'Member Exclusive',
      message: 'Free delivery on orders over $25 this week!',
      color: '#FF9800',
      action: 'Learn More'
    },
    {
      icon: '🗺️',
      title: 'Optimal Route',
      message: `${shoppingTasks.length} stores on your route - Save time & gas!`,
      color: '#9C27B0',
      action: 'Plan Route'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentPromo((prev) => (prev + 1) % promotions.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(timer);
  }, [promotions.length]);

  // Ensure banner is always visible
  // if (shoppingTasks.length === 0) return null;

  const promo = promotions[currentPromo];

  return (
    <div className="promotional-banner-strip">
      <div className="promo-text-container">
        <span className="promo-message-text">{promo.message}</span>
        <button className="promo-link-btn">
          {promo.action} ›
        </button>
      </div>
    </div>
  );
}

export default PromotionalBanner;
